import { mapGetters } from "vuex";

const domainsAndDateSelection = {
  computed: {
    ...mapGetters(["selectedDomains", "cookeSelectedDomains"]),
    selectedDomains() {
      return this.$store.state.auth.selectedDomains;
    },
    dates: {
      get() {
        return this.$store.getters["calendar/getDates"];
      },
      set(val) {
        this.$store.commit("calendar/setDates", val);
      }
    }
  }
};

export default domainsAndDateSelection;
